const StaticResourcesBaseUrl = "https://static.babys-im-glueck.de/";
export const ContentBaseUrl = StaticResourcesBaseUrl + "content/";
export const ImageBaseUrl = StaticResourcesBaseUrl + "img/";
